<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
import { onMounted, ref, shallowRef, watch } from 'vue';

// eslint-disable-next-line vue/define-props-declaration
const props = defineProps(nodeViewProps);

onMounted(() => {
  isPlacholderVisible.value = props.editor.isEditable;
});

const title = ref(props.node.attrs.title);
const bodyText = ref(props.node.attrs.bodyText);
const isPlacholderVisible = shallowRef(true);

watch(title, () => {
  props.updateAttributes({ title: title.value });
});

watch(bodyText, () => {
  props.updateAttributes({ bodyText: bodyText.value });
});
</script>

<template>
  <NodeViewWrapper>
    <div
      class="flex flex-col gap-1 border-primary-400 border-[2px] rounded-md relative my-4"
    >
      <p
        class="!font-semibold !text-sm absolute -top-[10px] ml-2 bg-white border-primary-400 border-[2px] px-4 rounded-md"
      >
        <span class="text-xs">#</span>{{ title }}
      </p>

      <span
        v-if="isPlacholderVisible"
        class="absolute top-[45%] px-4 text-gray-400"
      >
        Tuliskan sebuah pesan
      </span>

      <span
        :class="[
          'p-4 pt-6 caret-primary-500 focus:caret-primary-500 relative ',
        ]"
        :contenteditable="props.editor.isEditable"
        @blur="
          (e: Event) => {
            const text = (e.target as HTMLElement).innerText;
            bodyText = text;
            isPlacholderVisible = text === '' || text === '\n';
          }
        "
        @focus="isPlacholderVisible = false"
        @keyup="
          (e: Event) => {
            const text = (e.target as HTMLElement).innerText;
            console.log(text);
            isPlacholderVisible = text === '' || text === '\n';
          }
        "
      >
        {{ bodyText }}
      </span>
    </div>
  </NodeViewWrapper>
</template>
